










import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { InvestmentManagementType } from "@/shared/types";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { formatCurrency } from "@/shared/currency";

@Component({})
export default class InvestmentAccountTypeFeeDetails extends Vue {
  @Prop()
  accountType: InvestmentManagementType;

  @Prop()
  isHsaBank: boolean;

  enrollmentStore = useEnrollmentStore();

  mounted (): void {
    this.enrollmentStore.loadFees();
  }

  get accountFees () {
    return this.enrollmentStore.investmentFeeForAccountType(this.accountType);
  }

  get annualFee () {
    if (this.accountFees === null) {
      return 0.00;
    }

    return (this.accountFees.annualBasis / 100).toFixed(2);
  }

  get hasQuarterlyMin () {
    if (this.accountFees === null) {
      return false;
    }
    return this.accountFees.quarterlyMinimum > 0;
  }

  get hasQuarterlyMax () {
    if (this.accountFees === null) {
      return false;
    }
    return this.accountFees.quarterlyMaximum > 0;
  }

  get quarterlyMinText () {
    if (!this.hasQuarterlyMin) {
      return "";
    }

    return `Quarterly min: ${formatCurrency(this.accountFees.quarterlyMinimum)}`;
  }

  get quarterlyMaxText () {
    if (!this.hasQuarterlyMax) {
      return "";
    }

    return `Quarterly max: ${formatCurrency(this.accountFees.quarterlyMaximum)}`;
  }

  noBottomMargin (condition: boolean) {
    return {
      "mb-0": condition
    };
  }
}
